import { defineComponent, inject, openBlock, createElementBlock, withKeys, createVNode, unref } from "vue";
import { CdrFilmstripEventKey, CdrImg } from "@rei/cedar";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "ProductReviewsImageFrame",
  props: {
    caption: {},
    id: {},
    sizes: {},
    sizesOrder: {},
    photoIndex: {},
    reviewIndex: {}
  },
  setup(__props) {
    const props = __props;
    const emitEvent = inject(CdrFilmstripEventKey);
    const onFrameClick = (event) => {
      emitEvent == null ? void 0 : emitEvent("frameClick", {
        event,
        item: props
      });
    };
    return (_ctx, _cache) => {
      var _a, _b;
      return openBlock(), createElementBlock("div", {
        class: "image-carousel__image-container",
        "data-ui": "carousel-image-frame",
        onClick: onFrameClick,
        onKeydown: withKeys(onFrameClick, ["enter"])
      }, [createVNode(unref(CdrImg), {
        id: _ctx.id,
        src: (_b = (_a = _ctx.sizes) == null ? void 0 : _a.normal) == null ? void 0 : _b.Url,
        alt: "User uploaded product image",
        fit: "cover",
        ratio: "1/1",
        class: "image-carousel__image"
      }, null, 8, ["id", "src"])], 32);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=ProductReviewsImageFrame2.mjs.map
